import {checkIfSpecialBuilding} from "../../../buildings/checkIfSpecialBuilding";
import {
  createCommonBuildingCellAvailabilityCheck
} from "../calculateAvailableConstructionCellsForCommonBuilding";
import {
  calculateAvailableConstructionCellsForSpecialBuilding
} from "../calculateAvailableConstructionCellsForSpecialBuilding";
import {buildConstructionPlanningViewState} from "./buildConstructionPlanningViewState";

const checkIfEntryReachable = (state, entry, otherEntries) => {
  const viewState = buildConstructionPlanningViewState(state, {entries: otherEntries, brushToken: entry.token});
  // Пользователь не участник партии — судить не о чем
  if (!viewState) {
    return true;
  }
  if (checkIfSpecialBuilding(entry.token)) {
    return calculateAvailableConstructionCellsForSpecialBuilding(viewState).includes(entry.hexKey);
  }
  return createCommonBuildingCellAvailabilityCheck(viewState)(entry.hexKey);
};

/**
 * Записи плана, до которых больше нельзя провести путь строительства.
 *
 * Пути строительства идут от городов игрока и не проходят сквозь города
 * соперников, поэтому чужая стройка может отрезать запланированное: например,
 * соперник ставит казарму на месте первой из двух запланированных дорог —
 * казарма входит в его город, и до второй дороги путь уже не провести.
 *
 * Проверяется ТОЛЬКО достижимость (те же ячейки, что игра подсвечивает для
 * строения, — availableCells из calculateConstructionCells), без прочих
 * ограничений правил: для них у плана свои правила снятия
 * (см. constructionPlanMiddleware).
 *
 * Порядок записей не важен — как и при клике планирования: запись достижима
 * через настоящие строения и ВСЕ остальные записи плана. Иначе снималась бы
 * законная запись, путь к которой идет через запланированное позже, а игра
 * тут же позволила бы поставить ее обратно. Из остальных исключаются только
 * записи на той же ячейке, запланированные позже (спецстроение на этом
 * квартале): отложенное строение исключает свою ячейку из доступных.
 *
 * Снятие повторяется, пока что-то снимается: запись может держаться на
 * другой, которая сама недостижима, — например спецстроение на квартале,
 * до которого пути нет.
 *
 * @param {Object} state - состояние после чужой стройки
 * @param {Array<{hexKey: string, token: string}>} entries - оставшийся план
 * @returns {Array<{hexKey: string, token: string}>} недостижимые записи
 */
export const collectUnreachablePlanEntries = (state, entries) => {
  let keptEntries = entries;
  let isChanged = true;

  while (isChanged) {
    const currentEntries = keptEntries;
    keptEntries = currentEntries.filter((entry, index) => {
      const otherEntries = currentEntries.filter((other, otherIndex) => (
        otherIndex < index || (otherIndex > index && other.hexKey !== entry.hexKey)
      ));
      return checkIfEntryReachable(state, entry, otherEntries);
    });
    isChanged = keptEntries.length !== currentEntries.length;
  }

  return entries.filter((entry) => !keptEntries.includes(entry));
};
